<template>
    <ToggleSimple @update:open="toggleOpen = $event">
        <template #toggle>
            <div class="left">
                <div v-if="$te(`fields.${name}.label`)" class="toggle-text">
                    {{ $t(`fields.${name}.label`) }}
                    <span v-if="count.selected && count.selected > 0">{{ count.selected }}</span>
                </div>
                <div v-if="$te(`fields.${name}.description`)" class="toggle-description">
                    {{ $t(`fields.${name}.description`) }}
                </div>
            </div>
            <div class="right">
                <div v-if="isActive" class="reset" @click="resetSection">
                    <div class="icon-reset-pos"></div>
                </div>
                <div class="toggle-icon"></div>
            </div>
        </template>

        <template #content>
            <div :class="cssClassOptions">
                <CustomCheckbox
                    :modelValue="modelValue"
                    :inputKey="name"
                    @update:modelValue="onChanged"
                    :options="options"
                    cssClass="custom-checkbox-type-5"
                    :showLabel="false"
                    :showDescription="false"
                    ref="optionsOrgtypes"
                />
            </div>
        </template>
    </ToggleSimple>
</template>

<script>
    import { orgtypeMap } from '@/utils/maps/orgtypeMap';
    import CustomCheckbox from '@/components/inputs/CustomCheckbox';
    import ToggleSimple from '@/components/misc/ToggleSimple';

    export default {
        name: "OptionsOrgType",
        components: {
            ToggleSimple,
            CustomCheckbox
        },
        props: {
            modelValue: {
                type: Array,
                default: () => []
            },
            defaultVal: {
                type: Array,
                default: () => []
            },
            showDescriptions: {
                type: Boolean,
                default: true
            },
            cssClassOptions: {
                type: String,
                default: 'options-type-4'
            }
        },
        data() {
            return {
                name: 'orgtype_alt',
                toggleOpen: false,
            };
        },
        computed: {
            isActive() {
                return JSON.stringify(this.modelValue) !== JSON.stringify(this.defaultVal);
            },
            options() {
                return orgtypeMap.map(option => ({
                    noTranslate: true,
                    text: option.name,
                    value: option.value
                }));
            },
            count() {
                return {
                    total: this.options.length,
                    selected: this.modelValue.length,
                    not_selected: this.options.length - this.modelValue.length
                }
            }
        },
        methods: {
            resetSection(event = null) {
                if (event) {
                    event.stopPropagation()
                }
                this.$emit('update:modelValue', []);
            },
            onChanged(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        }
    }
</script>